import { render, staticRenderFns } from "./WaModal.vue?vue&type=template&id=513c87e0"
import script from "./WaModal.vue?vue&type=script&lang=js"
export * from "./WaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports